// wellnessFormFields.js
export const wellnessFormFields = [
  {
    id: "aaiCode",
    label: "Please input your AAI code (e.g., AAI123456)",
    type: "text",
    required: true
  },
  {
    id: "firstName",
    label: "First Name",
    type: "text",
    required: true
  },
  {
    id: "lastName",
    label: "Last Name",
    type: "text",
    required: true
  },
  {
    id: "age",
    label: "Age",
    type: "number",
    required: true
  },
  {
    id: "gender",
    label: "Gender",
    type: "radio",
    options: ["Male", "Female", "Other"],
    required: true
  },
  {
    id: "height",
    label: "Height (in ft/inches)",
    type: "text"
  },
  {
    id: "weight",
    label: "Weight (in kgs)",
    type: "number"
  },
  {
    id: "pregnant",
    label: "Are you pregnant?",
    type: "radio",
    options: ["Yes", "No"]
  },
  {
    id: "birthType",
    label: "How were you born?",
    type: "radio",
    options: ["Caesarean", "Normal/Vaginal", "Don't Know"]
  },
  {
    id: "birthPremature",
    label: "Was your birth premature?",
    type: "radio",
    options: ["Yes", "No"]
  },
  {
    id: "residence",
    label: "Currently residing in (town/city)",
    type: "text"
  },
  {
    id: "petInteraction",
    label: "Do you interact frequently with pet/farm animals?",
    type: "checkbox",
    options: ["None", "Cat", "Dog", "Goat", "Cow", "Birds", "Chickens", "Other"]
  },
  {
    id: "exerciseFrequency",
    label: "How often do you exercise?",
    type: "radio",
    options: [
      "Once a day - light",
      "Once a day - vigorous",
      "At least thrice a week - light",
      "At least thrice a week - vigorous",
      "Never"
    ]
  },
  {
    id: "smokingFrequency",
    label: "How often do you smoke?",
    type: "radio",
    options: ["More than once a day", "Once a day", "Sometimes", "Never"]
  },
  {
    id: "sleepIssues",
    label: "Do you frequently have any sleep-related issues?",
    type: "checkbox",
    options: [
      "I have a restful sleep",
      "Insomnia",
      "Trouble falling asleep",
      "Waking up in the middle of the night",
      "Sleep paralysis",
      "Sleep apnea",
      "Narcolepsy",
      "Other"
    ]
  },
  {
    id: "energyIssues",
    label: "Do you frequently experience any of the following?",
    type: "checkbox",
    options: [
      "Low energy levels", "Fatigue", "Frequent body aches",
      "Lethargy", "Mental fog", "None of the above"
    ]
  },
  {
    id: "stoolType",
    label: "What best describes your regular stool type?",
    type: "radio",
    options: [
      "Type 1 (Hard Lumps like stones or nuts)",
      "Type 2 (Sausage-shaped feces with lumps)",
      "Type 3 (Sausage-shaped feces with cracks)",
      "Type 4 (Soft snake-like feces)",
      "Type 5 (Feces in the form of soft lumps)",
      "Type 6 (Porous and soft feces)",
      "Type 7 (Watery stool)"
    ]
  },
  {
    id: "dietType",
    label: "Please mention your diet type",
    type: "checkbox",
    options: [
      "Veg", "Non-Veg", "Vegan", "Jain", "Eggetarian", "Pescatarian",
      "Non-frequent meat eater", "Ovo-lacto vegetarian", "Keto", "Paleo",
      "Intermittent Faster", "High Carbohydrate", "High Fat", "High Fibre",
      "High Protein", "Other"
    ]
  },
  {
    id: "milkConsumption",
    label: "What is the consumption frequency of milk/ whole milk/ cream/ ice cream in your diet?",
    type: "radio",
    options: ["More than 3 times a week", "1-2 times a week", "1-2 times a month", "Rarely", "Never"]
  },
  {
    id: "lowFatDairyConsumption",
    label: "What is the consumption frequency of Low fat milk, Cheese, Cream cheese, Butter, Ghee in your diet?",
    type: "radio",
    options: ["More than 3 times a week", "1-2 times a week", "1-2 times a month", "Rarely", "Never"]
  },
  {
    id: "otherDairy",
    label: "Do you consume any other milk products?",
    type: "text"
  },
  {
    id: "fruitVegConsumption",
    label: "What is the frequency of fruits, vegetables and salads in your diet?",
    type: "radio",
    options: ["More than 3 times a week", "1-2 times a week", "1-2 times a month", "Rarely", "Never"]
  },
  {
    id: "carbsConsumption",
    label: "What is the frequency of White rice, bread, maida etc in your diet?",
    type: "radio",
    options: ["More than 3 times a week", "1-2 times a week", "1-2 times a month", "Rarely", "Never"]
  },
  {
    id: "meatConsumption",
    label: "What is the frequency of red meat, white meat and processed meat in your diet?",
    type: "radio",
    options: ["More than 3 times a week", "1-2 times a week", "1-2 times a month", "Rarely", "Never"]
  },
  {
    id: "eggFrequency",
    label: "What is the frequency of the egg in your diet?",
    type: "radio",
    options: ["More than 3 times a week", "1-2 times a week", "1-2 times a month", "Rarely", "Never"]
  },
  {
    id: "fishFrequency",
    label: "What is the frequency of fishes/ shellfishes in your diet?",
    type: "radio",
    options: ["More than 3 times a week", "1-2 times a week", "1-2 times a month", "Rarely", "Never"]
  },
  {
    id: "grainsLegumes",
    label: "What is the frequency of whole grains, beans or lentils (dal) and legumes in your diet?",
    type: "radio",
    options: ["More than 3 times a week", "1-2 times a week", "1-2 times a month", "Rarely", "Never"]
  },
  {
    id: "alcohol",
    label: "How often do you consume alcohol?",
    type: "radio",
    options: ["Daily", "Once a week", "Sometimes", "I don't consume alcohol"]
  },
  {
    id: "antibiotics",
    label: "Have you taken any antibiotics in last 1 month?",
    type: "text"
  },
  {
    id: "infections",
    label: "Have you had any of the following infectious diseases in the last 6 months?",
    type: "checkbox",
    options: [
      "None", "Hepatitis", "Typhoid", "Jaundice", "Helicobacter pylori infection",
      "Clostridium difficile infection", "UTI", "Fungal infection", "Other"
    ]
  },
  {
    id: "neuroConditions",
    label: "Do you have any of the following neurological conditions?",
    type: "checkbox",
    options: [
      "None", "Epilepsy seizure disorder", "Alzheimer's disease", "Huntington's disease",
      "Bipolar", "Schizophrenia", "Autism", "Other"
    ]
  },
  {
    id: "hormonalIssues",
    label: "Do you have any of the following hormonal imbalance?",
    type: "checkbox",
    options: [
      "None", "Type 1 Diabetes", "Type 2 Diabetes", "Gestational Diabetes",
      "Hyperthyroidism", "Hypothyroidism", "PCOD", "Other"
    ]
  },
  {
    id: "respiratory",
    label: "Do you have any of the following respiratory illnesses?",
    type: "checkbox",
    options: [
      "None", "Asthma", "COPD", "Bronchitis", "Cystic Fibrosis", "Pulmonary Edema", "Other"
    ]
  },
  {
    id: "cardiac",
    label: "Do you have history of any of the following cardiovascular/ heart disease?",
    type: "checkbox",
    options: [
      "None", "Angina and myocardial infarction", "Atrial fibrillation",
      "Rheumatic heart disease", "Abnormal heart rhythms", "Heart failure", "Hypertension", "Other"
    ]
  },
  {
    id: "autoimmune",
    label: "Do you have any of the following autoimmune disease?",
    type: "checkbox",
    options: [
      "None", "Rheumatoid Arthritis", "Celiac Disease", "Eczema",
      "Multiple Sclerosis (MS)", "Psoriasis", "Ankylosing spondylitis (AS)", "Other"
    ]
  },
  {
    id: "postMealSymptoms",
    label: "Do you frequently experience any of the following after eating?",
    type: "checkbox",
    options: [
      "None", "Abdominal discomfort", "Abdominal pain", "Fullness or bloating of tummy",
      "Acidity or heart burn", "Chest discomfort", "Migraine", "Other"
    ]
  },
  {
    id: "gutIssues",
    label: "Do you frequently experience any gut-related issues?",
    type: "checkbox",
    options: [
      "None", "Acid reflux/ sour taste in mouth", "Burping/ belching", "Flatulence/ gas",
      "Constant itching or thrush in the mouth", "Bad breath", "A sense of incomplete emptying or multiple small bowel movements",
      "Motions right after eating", "Frequent loose motions or upset tummy",
      "Relieving of tummy pain after stool passage", "Mucus in stool", "Hard stools or straining", "Other"
    ]
  },
  {
    id: "gutAutoimmune",
    label: "Have you been diagnosed with any of the following gut-related Autoimmune Disorders?",
    type: "checkbox",
    options: ["None", "Ulcerative Colitis", "Crohn's Disease", "IBS", "SIBO", "Other"]
  },
  {
    id: "foodAllergies",
    label: "Are you allergic to any of the following food items?",
    type: "checkbox",
    options: [
      "I don't know", "None", "Peanuts", "Egg", "Prawn", "Fish", "Eggplant", "Legume", "Shellfish",
      "Almonds", "Brazil Nuts", "Cashew", "Hazelnuts", "Macadamia Nuts", "Milk", "Other Dairy products",
      "Pecans", "Pinenuts", "Pistachios", "Sesame", "Soybeans", "Walnuts", "Wheat", "Other"
    ]
  },
  {
    id: "foodIntolerances",
    label: "Are you intolerant to any specific food items?",
    type: "checkbox",
    options: ["I don't know", "None", "Lactose", "Gluten", "Other"]
  }
];
